import constant from '../../store/constant'
import config from '../../store/config'
var utils = require('../../utils')

export default {
  name: 'care-office-edit',
  data: function () {
    return {
      co: {
        careoffice_id: '',
        careoffice_history_id: '',
        careoffice_name: '',
        careoffice_name_furigana: '',
        post_no: '',
        address1: '',
        address2: '',
        tel: '',
        fax: '',
        email: '',
        send_type: '',
        enable_flag: 1,
        map_lat: '',
        map_lng: '',
        map_zoom: '',
        send_timing: 0,
        send_timing_hour: '0.0',
        fusezi_flag: 0,
        create_time: '',
        update_time: '',
        del_flag: 0,
        encrypted_password: '',
        reset_password_token: '',
        reset_password_sent_at: '',
        remember_created_at: '',
        sign_in_count: '',
        current_sign_in_at: '',
        last_sign_in_at: '',
        current_sign_in_ip: '',
        last_sign_in_ip: '',
        start_date: '',
        end_date: '',
        current_flag: ''
      },
      master: {
        careoffice_id: '',
        login_id: '',
        password: '',
        create_time: '',
        update_time: '',
        enable_flag: 1,
        del_flag: 0
      },
      chargeShops: [],
      sendTypes: [],
      images: [],
      change_date: '',

      selectedImage: null,
      editImageTitle: '',

      shopId: null,
      isNew: true,
      canValidate: true, // false -> true : "必須項目です"を初期表示するように対応。
      utils: utils,
      searchCallbackFlag: false // 検索結果フラグ
    }
  },

  created: function () {
    // this.$store.dispatch('SHOP_SEARCH')
    this.$store.dispatch('SHOP_SEARCH', {data: {all_get: true}, 'allShopName': this._self.$t('AllShopName'), callback: () => {}})

    if (this.$store.getters.canManage) {
      this.shopId = this.$store.getters.currentShopId
    }
    this.clearSearch()
    if ('careOfficeHisId' in this.$route.params) {
      // 更新
      this.isNew = false
      this.search()
    } else {
      // 新規

      // 送信タイプ
      this.co.send_timing = constant.clinic.default.send_timing
      this.co.send_timing_hour = constant.clinic.default.send_timing_hour

      // 自店舗デフォルト
      this.chargeShops = [this.shopId]

      this.searchCallbackFlag = true
    }
  },
  mounted: function () {
    if ('careOfficeHisId' in this.$route.params) {
      // ヘルプボタン表示
      utils.helpModalShow()
    }
    utils.googleMapEvent({
      js:          constant.js.google_maps,
      key:         config.google_map_api_key,
      mapElmId:    'map',
      lat:         null,
      lng:         null,
      zoom:        null,
      map_default: constant.map_default,
      mapCallback: this.mapCallback,
    })
  },

  /** 他画面への遷移前 */
  beforeRouteLeave (to, from, next) {
    utils.googleMapEventRemove() // google map イベント削除
    next()
  },

  computed: {
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    loading() {
      return this.$store.getters.apiLoading
    },
    /** 通知 */
    notify() {
      return this.$store.getters.careOfficeNotify
    },
    shops () {
      return this.$store.getters.shops.filter((o) => {return o.id != null}) // 全店舗は不可
    },
    /** 各日付 (和暦) */
    changeDate: {
      get: function () {return this.getWareki(this.change_date)},
      set: function (v) {this.change_date = this.getSeireki(v)}
    },
    /** 画像 */
    filteredImages () {
      return this.images.filter(function(item, index) {
        if (item.del_flag === 0) return true
      })
    },
    canAddImage: function () {
      return (this.filteredImages.length < constant.place_image_upload_limit)
    },
    uploadCounter () {
      var total = this.$store.getters.imageUploadTotal
      var current = this.$store.getters.imageUploadCurrent
      if (total < 1 || total === current) {
        return ''
      } else {
        return this.$t('Count', {'Count': current + '/' + total}) + this.$t('Image Upload Successful')
      }
    },
    uploadErrors () {
      return this.$store.getters.imageUploadErrors
    },
    uploadSuccess () {
      return this.$store.getters.imageUploadStatus
    },

    /** バリデーション */
    validation: function() {
      var v = {
        careoffice_name: !!this.co.careoffice_name,
        careoffice_name_furigana: utils.isHiragana(this.co.careoffice_name_furigana, false),
        post_no_requird: !!this.co.post_no,
        post_no_pattern: !this.co.post_no || utils.regex.post_no.test(this.co.post_no),
        address1: !!this.co.address1,
        address2: !!this.co.address2,
        tel_requird: !!this.co.tel,
        tel_pattern: !this.co.tel || utils.regex.tel.test(this.co.tel),
        fax_requird: !!this.co.fax,
        fax_pattern: !this.co.fax || utils.regex.tel.test(this.co.fax),
        chargeShops: (this.chargeShops.length > 0),
        sendTypes: (this.sendTypes.length > 0),
        // email: !utils.isBlank(this.co.email), // eMail必須チェック対応
        email_format: utils.isEmail(this.co.email),
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    },
  },

  methods: {
    /** (編集)初期表示 */
    search: function () {
      this.searchCallbackFlag = false
      this.$store.dispatch('CARE_OFFICE_SEARCH_HISTORY', {
        loadparam: 'block',
        data: { careoffice_history_id: this.$route.params.careOfficeHisId },
        callback: this.onGetCareOffice
      })
    },
    onGetCareOffice: function(data) {
      if (data === null) {
        // this.searchCallbackFlag = true
        this.goPrev()
        return
      }
      for (var key in this.co) {
        this.co[key] = data.history[key];
      }
      for (var key in this.master) {
        this.master[key] = data.master[key];
      }
      this.chargeShops = []
      for (var o of data.shops) {
        this.chargeShops.push(o.id)
      }
      this.images = []
      for (var o of data.images) {
        this.images.push(o)
      }
      this.sendTypes = this.sendTypeToArray(this.co.send_type)
      utils.googleMapEvent({
        js:          constant.js.google_maps,
        key:         config.google_map_api_key,
        mapElmId:    'map',
        lat:         this.co.map_lat,
        lng:         this.co.map_lng,
        zoom:        this.co.map_zoom,
        mapCallback: this.mapCallback,
        map_default: constant.map_default
      })
      this.searchCallbackFlag = true
    },
    clearSearch: function () {
      this.$store.dispatch('CARE_OFFICE_EDIT_CLEAR')
    },

    /** タブ切り替え */
    goFacilities: function () {
      this.$router.push({ path: '/facilities', query: { type: this.$router.currentRoute.query.type } })
    },
    goFacilityPersons: function () {
      this.$router.push({ path: '/facility_persons', query: { type: this.$router.currentRoute.query.type } })
    },
    goDoctors: function () {
      this.$router.push({ path: '/doctors', query: { type: this.$router.currentRoute.query.type } })
    },
    goClinics: function () {
      this.$router.push({ path: '/clinics', query: { type: this.$router.currentRoute.query.type } })
    },
    goCareManagers: function () {
      this.$router.push({ path: '/care_managers', query: { type: this.$router.currentRoute.query.type } })
    },
    goCareOffices: function () {
      this.$router.push({ path: '/care_offices', query: { type: this.$router.currentRoute.query.type, keep: 'true'} })
    },

    /** 送付方法 */
    sendTypeToArray: function (type) {
      var array = []
      for (var v of [constant.send_type.postal, constant.send_type.fax, constant.send_type.email]) {
        if (type & v) array.push(v)
      }
      return array
    },
    arrayToSendType: function (array) {
      var type = 0
      for (var v of array) {
        type += utils.str2int(v)
      }
      return type
    },
    /** 基準日 */
    getReferenceDate: function () {
      var start = this.getWareki(this.co.start_date)
      if (start == '')
        return ''
      var end = this.getWareki(this.co.end_date)
      if (end != '') {
        if (new Date(this.co.end_date).getFullYear() == this.$t('history.max_year')) {
          end = this.$t('history.max_display')
        }
      }
      return start + this.$t('history.delimiter') + end
    },

    /** 郵便番号入力補助 */
    onChangePostNo: function () {
      if (!!this.co.post_no && utils.regex.post_no.test(this.co.post_no)) {
        this.$store.dispatch('ADDRESS_GET', {
          postal_code: this.co.post_no, callback: (addr) => {
            if (addr) {
              this.co.address1 = addr.address1
              this.co.address2 = addr.address2
              this.onChangeAddress()
            }
          }
        })
      }
    },

    /** 住所変更時イベント */
    onChangeAddress: function () {
      var arr = []
      if (utils.isPresent(this.co.post_no)) arr.push(this.co.post_no)
      if (utils.isPresent(this.co.address1)) arr.push(this.co.address1)
      if (utils.isPresent(this.co.address2)) arr.push(this.co.address2)
      if (arr.length > 0) {
        var address = arr.join(' ')
        if (window.googleMapsQuerySearch) {
          window.googleMapsQuerySearch(address)
        }
      }
    },

    /** 画像アップロード */
    onDragOver: function (event) {
      var files = event.dataTransfer.items
      if (files && (files.length + this.filteredImages.length > constant.place_image_upload_limit)) {
        event.dataTransfer.dropEffect = "none"
      }
      event.preventDefault()
    },
    onDrop: function (event) {
      console.log('onDrop')
      // ブラウザ上でファイルを展開する挙動を抑止
      event.preventDefault()
      // ドロップされたファイルのfilesプロパティを参照
      var files = event.dataTransfer.files
      this.upload(files)
    },
    onFileChange: function (event) {
      console.log('onFileChange')
      // ドロップされたファイルのfilesプロパティを参照
      var files = event.target.files
      this.upload(files)
    },
    uploadStart: function () {
      this.$store.dispatch('UPLOAD_START')
    },
    upload: function (files) {
      if (!files)
        return
      if (files.length + this.filteredImages.length > constant.place_image_upload_limit)
        return
      for (var i=0; i<files.length; i++) {
        var formData = new FormData()
        formData.append('image_attach[cache_id]', files[i])
        this.$store.dispatch('IMAGE_UPLOAD', { data: formData, callback: this.onUpload })
      }
    },
    onUpload: function (data) {
      var img = {}
      img.id = null
      img.title = data.title
      img.image_attach_id = null
      img.cache_id = data.cache_id
      img.cache_id_cache = data.cache_id_cache
      img.image_path = data.image_path
      img.del_flag = 0
      this.images.push(img)
    },
    removeImage: function (img) {
      img.del_flag = 1
    },

    /** 画像押下 */
    onClickImageModalShow: function (image) {
      var button = document.getElementById('imageModalButton')
      var img    = document.getElementById('imageModalImg')
      var text   = document.getElementById('imageModalText')
      img.src = image.image_path + '?token=' + this.authToken
      text.textContent = image.title
      button.click() // モーダル表示 イベント発火
    },
    /** 画像タイトルリンク */
    showImageTitleEditModal: function (image) {
      this.selectedImage = image
      this.editImageTitle = image.title
      this.$refs.editTitleBtn.click()
    },
    saveTitle: function () {
      this.selectedImage.title = this.editImageTitle
    },
    /** 画像登録ボタン */
    showUploadModal: function () {
      if (this.canAddImage) {
        this.$store.dispatch('IMAGE_UPLOAD_START', {})
        this.$refs.uploadBtn.click()
      }
    },

    /** マーククリアボタン */
    onClickMapMarkClear: function () {
      utils.googleMapEventMarkaClear()
      this.co.map_lat = null
      this.co.map_lng = null
      this.co.map_zoom = null
    },

    /** 郵便番号 */
    onChangePostNo: function () {
      if (!!this.co.post_no && utils.regex.post_no.test(this.co.post_no)) {
        this.$store.dispatch('ADDRESS_GET', {
          postal_code: this.co.post_no, callback: (addr) => {
            if (addr !== null) {
              this.co.address1 = addr.address1
              this.co.address2 = addr.address2
            }
          }
        })
      }
    },

    /** 保存ボタン押下 */
    onClickSave: function () {
      this.canValidate = true
      if (!this.isValid) {
        return
      }

      // 電話番号重複チェック
      this.$store.dispatch('CARE_OFFICE_DUPLICATE_CHECK', {
        data: {
          careoffice_id: this.co.careoffice_id,
          tel: this.co.tel
        },
        callback: (result) => {
          if (result) {
            var button = document.getElementById('duplicate_tel_modal_button')
            button.click() // モーダル表示 イベント発火
          } else {
            this.save()
          }
        }
      })
    },

    /** 保存 */
    save: function(){
      this.co.send_type = this.arrayToSendType(this.sendTypes)
      var data = {
        master: this.master,
        history: this.co,
        shops: this.chargeShops,
        images: this.images,
        change_date: this.change_date
      }
      this.$store.dispatch('CARE_OFFICE_EDIT', { data: data, callback: this.onSaved })
    },
    onSaved: function () {
      this.goPrev()
    },

    /** キャンセルボタン */
    goPrev: function () {
      if (this.isNew) {
        this.goCareOffices()
      } else {
        var query = { type: this.$router.currentRoute.query.type, keep: 'true'}
        this.$router.push({ path: '/care_offices/' + this.co.careoffice_id, query: query })
      }
    },
    mapCallback: function(lat, lng, zoom) {
      this.co.map_lat = lat
      this.co.map_lng = lng
      this.co.map_zoom = zoom
    },

    /** 日付 (和暦) 用 */
    getWareki: function (seireki_str) {
      if ((!seireki_str) || isNaN(Date.parse(seireki_str))) {
        return ''
      } else {
        return utils.sereki2Wareki(this.$t, new Date(Date.parse(seireki_str)))
      }
    },
    getSeireki: function (wareki_str) {
      var seireki = utils.wareki2Seireki(this.$t, wareki_str)
      return !!seireki ? seireki.toLocaleDateString() : ''
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/care-office-edit.js